import L from 'leaflet'
import 'leaflet.markercluster'
import {initSvgIcon} from "../utils/icon";

function isFloat(n) {
    return Number(Number.parseFloat(n)) === n && n % 1 !== 0;
}

export class LeafletFilteredMap {

    defaultZoom = 10;
    defaultIcon;

    constructor(idCss, options) {
        if ($("#"+idCss).length) {
            this.map = L.map(idCss, options);
            this.markerClusterGroup = new L.markerClusterGroup({showCoverageOnHover: false}).addTo(this.map);
            this.layerGroup = L.layerGroup().addTo(this.markerClusterGroup);
            this.resize();
            $('.leaflet-control-container div').first().attr('class', '')
                .addClass("leaflet-bottom leaflet-left")
        } else {
            console.error("Selector '"+idCss+"' not exist.")
        }

        this.defaultIcon = L.icon({
            iconUrl: imageBase+'leaflet-marker.png',
            iconSize: [43, 43],
            // iconAnchor: [22, 94],
            // popupAnchor: [-3, -76],
            // shadowSize: [68, 95],
            // shadowAnchor: [22, 94]
        });
        // this.defaultIcon = L.divIcon({
        //     className: 'custom-leaflet-icon',
        //     html: "<div class='marker-number'>" +
        //         "<svg data-icon='marker-leaflet'>" +
        //         "</div>",
        //     iconSize: [32, 32],
        //     iconAnchor: [32, 32]
        // });
    }

    load_WP_Post(posts) {
        let _this = this
        posts.forEach(function(post) {
            if (isFloat(post.lat) && isFloat(post.lng) && post.id) {
                L.marker([post.lat, post.lng], {
                    icon:  _this.defaultIcon,
                    alt: post.id,
                    id: post.id
                })
                    // .on('click', _this.clickZoom)
                    .addTo(_this.layerGroup).addTo(_this.markerClusterGroup)
                    .bindPopup(post.popin);
            }
        });
    }

    clickZoom(e) {
        this.map.setView(e.target.getLatLng(), 19);
    }

    clearMarkers() {
        this.markerClusterGroup.clearLayers();
    }

    markerClick(e) {
        clickZoom(e);
    }

    resize(timeout = 10) {
        setTimeout(() => this.map.invalidateSize(true), timeout);
    }
}
